import {mapValues, min} from 'lodash';
import {ReactNode, useMemo} from 'react';
import Masonry from 'react-masonry-css';
import styles from './MasonryGrid.module.scss';

const breakpoints = {
  default: 4,
  1200: 3,
  800: 2,
  550: 1,
};

type MasonryGridProps = {
  maxColumns?: number;
  children: ReactNode;
};

export default function MasonryGrid(props: MasonryGridProps) {
  const bp = useMemo(() => {
    if (props.maxColumns) {
      return mapValues(breakpoints, (v) => min([props.maxColumns, v]));
    } else {
      return breakpoints;
    }
  }, [props.maxColumns]) as typeof breakpoints;

  return (
    <Masonry breakpointCols={bp} className={styles.container} columnClassName={styles.column}>
      {props.children}
    </Masonry>
  );
}
